export default __webpack_public_path__ + "static/media/UserGuide.deeb2c6e.pdf";